import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import { shopCategoryMainNames } from "../../helpers/Utils";

export const getShopCategories = (isPVM25 = false) => {
  antdAsyncMessageLoading({
    key: "getShopCategories",
    text: "Fetching shop categories...",
  });
  return Axios.get(
    isPVM25 ? `/api/v1/categories/pvm25` : "/api/v1/categories/filter"
  )
    .then((res) => {
      const items = res.data;
      if (!Array.isArray(items)) throw new Error("ERR");

      const processedItems = items.map((item) => ({
        ...item.children[0],
        identifier: item.identifier,
        children: item.children?.[0]?.children?.[0]?.children || [],
      }));

      antdAsyncMessageSuccess({
        key: "getShopCategories",
        text: "Fetched shop categories",
      });

      return {
        success: true,
        data: processedItems,
      };
    })
    .catch((e) => {
      console.log("ERROR: ", e);
      antdAsyncMessageError({
        key: "getShopCategories",
        text: "Error fetching shop categories",
      });
      return {
        success: false,
        data: [],
      };
    });
};
export const getShopCategoriesOptions = async (filtStr) => {
  try {
    const { data } = await Axios.get(`/api/v1/shop_categories?${filtStr}`);
    return {
      success: true,
      data: data.filter(
        (d) => Array.isArray(d.children) && d.children.length > 0
      ),
    };
  } catch (err) {
    console.log("Error");
  }
};

export const getShopCategoriesAllOptions = async () => {
  try {
    const { data } = await Axios.get("/api/v1/shop_categories/all");
    return {
      success: true,
      data,
    };
  } catch (err) {
    console.log("Error");
  }
};

export const getBrandsOptions = () => {
  return Axios.get(`/api/v1/brands`).then((res) => {
    return res.data;
  });
};

export const updateShopCategory = async (id, params) => {
  await Axios.put(`/api/v1/shop_categories/${id}`, { shop_category: params });
  console.log("UPDT");
};

export const createShopCategory = async (id, params) => {
  const response = await Axios.post(`/api/v1/shop_categories`, {
    shop_category: params,
  });
  console.log("POST");
  return response.data;
};

export const updateShopCategories = (body) => {
  antdAsyncMessageLoading({
    key: "updateShopCategories",
    text: "Mass updating...",
  });

  return Axios.post(`/api/v1/shop_categories/mass_save`, body)
    .then(async () => {
      antdAsyncMessageSuccess({
        key: "updateShopCategories",
        text: "Mass updated",
      });
      const { data } = await getShopCategories(true);
      return { success: true, data };
    })
    .catch(() => {
      antdAsyncMessageError({
        key: "updateShopCategories",
        text: "Mass updating unvalid",
      });
      return { success: false, data: [] };
    });
};
